<template>
  <div class="error-message-container" :class="[errored ? 'error-message-container-open' : '']">
    <p>{{message}}</p>
  </div>
</template>
<script>
export default {
  props: ["errored", "message"],
  data: function() {
    return {};
  },
  methods: {}
};
</script>

<style scoped>
.error-message-container {
  position: fixed;
  top: -100%;
  left: 0;
  width: 100%;
  text-align: center;
  color: red;
  font-weight: bold;
  padding: 1rem;
  transition: 0.3s ease-in-out;
  background: lightgrey;
  z-index: 3;
}
.error-message-container-open {
  top: 0;
}
</style>
